import { Brand } from '../types';
import { Icon } from './Icon';
import { SmallIcon } from './SmallIcon';
import { Theme } from './Theme';

export const BlastTheme: Brand = {
  Theme,
  SmallIcon,
  Icon,
};
